import { configureStore } from "@reduxjs/toolkit";
import accountReducer from "view/account/store/slice";
import contactUsReducer from "view/contact-us/store/slice";
import homeReducer from "view/home/store/slice";
import memberReducer from "view/members/store/slice";
import preferenceReducer from "view/preference/store/slice";
import profileReducer from "view/profile/store/slice";
import quickUploadReducer from "view/quick-upload/store/slice";
import searchProfileReducer from "view/search-profile/store/slice";
import globalReducer from "./slice";

export default configureStore({
  reducer: {
    global: globalReducer,
    home: homeReducer,
    profile: profileReducer,
    searchProfile: searchProfileReducer,
    member: memberReducer,
    preference: preferenceReducer,
    account: accountReducer,
    contactUs: contactUsReducer,
    quickUpload: quickUploadReducer,
  },
});
